import React, { useState } from 'react';
import { BilingualText } from '../components/BilingualText';
import { ArrowLeft, User, Shield, Warehouse, Truck, History, Lock, Mail, Phone, MapPin, CheckCircle2, XCircle, AlertCircle, ChevronRight, Edit2 } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
export function UserDetails() {
  const [activeTab, setActiveTab] = useState<'info' | 'permissions' | 'activity'>('info');
  const navigate = useNavigate();
  const user = {
    name: 'Ahmed Ali',
    email: 'ahmed@warehouse.com',
    role: 'Warehouse Staff',
    status: 'Active',
    warehouse: 'Riyadh Main (WH-01)',
    mobile: '+966 50 123 4567',
    lastLogin: 'July 11, 2026 • 10:15 AM',
    createdDate: 'January 15, 2026'
  };
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-1202">
      <header className="bg-white px-4 py-6 border-b border-slate-200 flex items-center justify-between sticky top-0 z-10 lg:px-8" data-id="element-1203">
        <div className="flex items-center gap-4" data-id="element-1204">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-1205">
            <ArrowLeft size={24} data-id="element-1206" />
          </button>
          <BilingualText en="User Details" ar="تفاصيل المستخدم" className="text-xl font-bold" data-id="element-1207" />
        </div>
        <div className="flex gap-2" data-id="element-1208">
          <button className="btn-secondary py-2 px-4 text-sm" data-id="element-1209">
            <Lock size={18} data-id="element-1210" />
            <span data-id="element-1211">Reset Password</span>
          </button>
          <button className="btn-primary py-2 px-4 text-sm" data-id="element-1212">
            <Edit2 size={18} data-id="element-1213" />
            <span data-id="element-1214">Edit User</span>
          </button>
        </div>
      </header>

      <main className="p-4 md:p-8 max-w-5xl mx-auto space-y-8" data-id="element-1215">
        {/* Profile Header Card */}
        <div className="card p-6 md:p-8 flex flex-col md:flex-row items-center gap-6 bg-white" data-id="element-1216">
          <div className="w-24 h-24 rounded-full bg-[#2E3192] text-white flex items-center justify-center text-3xl font-bold border-4 border-blue-50" data-id="element-1217">
            AA
          </div>
          <div className="flex-1 text-center md:text-left space-y-2" data-id="element-1218">
            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4" data-id="element-1219">
              <h1 className="text-2xl font-bold text-slate-800" data-id="element-1220">{user.name}</h1>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-700 uppercase mx-auto md:mx-0" data-id="element-1221">
                {user.status}
              </span>
            </div>
            <div className="flex flex-col md:flex-row gap-2 md:gap-6 text-slate-500 text-sm" data-id="element-1222">
              <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-1223">
                <Mail size={16} data-id="element-1224" />
                {user.email}
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-1225">
                <Shield size={16} data-id="element-1226" />
                {user.role}
              </div>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="flex border-b border-slate-200 gap-8" data-id="element-1227">
          <TabButton active={activeTab === 'info'} onClick={() => setActiveTab('info')} en="Information" ar="المعلومات" data-id="element-1228" />
          <TabButton active={activeTab === 'permissions'} onClick={() => setActiveTab('permissions')} en="Permissions" ar="الصلاحيات" data-id="element-1229" />
          <TabButton active={activeTab === 'activity'} onClick={() => setActiveTab('activity')} en="Activity Log" ar="سجل النشاط" data-id="element-1230" />
        </div>

        {activeTab === 'info' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in fade-in duration-500" data-id="element-1231">
            <section className="card p-6 space-y-6" data-id="element-1232">
              <BilingualText en="Personal Information" ar="المعلومات الشخصية" className="text-lg" data-id="element-1233" />
              <div className="space-y-4" data-id="element-1234">
                <DetailItem label="Full Name" value={user.name} data-id="element-1235" />
                <DetailItem label="Email Address" value={user.email} data-id="element-1236" />
                <DetailItem label="Mobile Number" value={user.mobile} data-id="element-1237" />
                <DetailItem label="Created Date" value={user.createdDate} data-id="element-1238" />
              </div>
            </section>
            <section className="card p-6 space-y-6" data-id="element-1239">
              <BilingualText en="Account Settings" ar="إعدادات الحساب" className="text-lg" data-id="element-1240" />
              <div className="space-y-4" data-id="element-1241">
                <DetailItem label="Assigned Role" value={user.role} data-id="element-1242" />
                <DetailItem label="Primary Warehouse" value={user.warehouse} data-id="element-1243" />
                <DetailItem label="Last Login" value={user.lastLogin} data-id="element-1244" />
                <div className="pt-4" data-id="element-1245">
                  <button className="text-red-600 text-sm font-bold flex items-center gap-2 hover:bg-red-50 px-3 py-2 rounded-lg transition-colors" data-id="element-1246">
                    <XCircle size={18} data-id="element-1247" />
                    <span data-id="element-1248">Deactivate Account</span>
                  </button>
                </div>
              </div>
            </section>
          </div>}

        {activeTab === 'permissions' && <div className="card overflow-hidden animate-in slide-in-from-bottom-4 duration-500" data-id="element-1249">
            <table className="w-full text-left" data-id="element-1250">
              <thead className="bg-slate-50 text-slate-400 text-xs uppercase tracking-wider" data-id="element-1251">
                <tr data-id="element-1252">
                  <th className="px-6 py-4 font-bold" data-id="element-1253">Module</th>
                  <th className="px-6 py-4 font-bold" data-id="element-1254">Access Level</th>
                  <th className="px-6 py-4 font-bold" data-id="element-1255">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-1256">
                <PermissionRow module="Shipment Management" level="View & Notes" allowed={true} data-id="element-1257" />
                <PermissionRow module="Appointment Management" level="Manage Calendar" allowed={true} data-id="element-1258" />
                <PermissionRow module="Check-in & Receiving" level="Full Operations" allowed={true} data-id="element-1259" />
                <PermissionRow module="User Management" level="No Access" allowed={false} data-id="element-1260" />
                <PermissionRow module="System Settings" level="No Access" allowed={false} data-id="element-1261" />
              </tbody>
            </table>
          </div>}

        {activeTab === 'activity' && <div className="card p-6 space-y-6 animate-in fade-in duration-500" data-id="element-1262">
            <BilingualText en="Recent Activity" ar="النشاط الأخير" className="text-lg" data-id="element-1263" />
            <div className="space-y-6 relative before:absolute before:left-4 before:top-2 before:bottom-2 before:w-0.5 before:bg-slate-100" data-id="element-1264">
              <ActivityItem action="Truck Checked-in" details="Plate: LKR 4920 (ASN-98231)" time="10:15 AM" icon={Truck} color="bg-blue-500" data-id="element-1265" />
              <ActivityItem action="Appointment Approved" details="APP-2026-042 for Global Logistics" time="09:45 AM" icon={CheckCircle2} color="bg-green-500" data-id="element-1266" />
              <ActivityItem action="User Login" details="IP: 192.168.1.45 (Riyadh, KSA)" time="08:30 AM" icon={User} color="bg-[#2E3192]" data-id="element-1267" />
            </div>
          </div>}
      </main>
    </div>;
}
function TabButton({
  active,
  onClick,
  en,
  ar
}: any) {
  return <button onClick={onClick} className={`pb-4 px-2 transition-all relative ${active ? 'text-[#2E3192] font-bold' : 'text-slate-400 hover:text-slate-600'}`} data-id="element-1268">
      <BilingualText en={en} ar={ar} className="text-sm" data-id="element-1269" />
      {active && <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#2E3192] rounded-t-full" data-id="element-1270" />}
    </button>;
}
function DetailItem({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div data-id="element-1271">
      <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1272">
        {label}
      </div>
      <div className="text-slate-700 font-medium" data-id="element-1273">{value}</div>
    </div>;
}
function PermissionRow({
  module,
  level,
  allowed
}: any) {
  return <tr data-id="element-1274">
      <td className="px-6 py-4 font-bold text-slate-700" data-id="element-1275">{module}</td>
      <td className="px-6 py-4 text-sm text-slate-600" data-id="element-1276">{level}</td>
      <td className="px-6 py-4" data-id="element-1277">
        {allowed ? <span className="flex items-center gap-1.5 text-green-600 text-xs font-bold" data-id="element-1278">
            <CheckCircle2 size={14} data-id="element-1279" />
            ENABLED
          </span> : <span className="flex items-center gap-1.5 text-slate-300 text-xs font-bold" data-id="element-1280">
            <XCircle size={14} data-id="element-1281" />
            DISABLED
          </span>}
      </td>
    </tr>;
}
function ActivityItem({
  action,
  details,
  time,
  icon: Icon,
  color
}: any) {
  return <div className="flex gap-4 relative z-10" data-id="element-1282">
      <div className={`w-8 h-8 rounded-full ${color} text-white flex items-center justify-center shrink-0 shadow-sm`} data-id="element-1283">
        <Icon size={16} data-id="element-1284" />
      </div>
      <div className="flex-1" data-id="element-1285">
        <div className="flex justify-between items-start" data-id="element-1286">
          <div className="font-bold text-slate-800 text-sm" data-id="element-1287">{action}</div>
          <div className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-1288">
            {time}
          </div>
        </div>
        <div className="text-xs text-slate-500 mt-0.5" data-id="element-1289">{details}</div>
      </div>
    </div>;
}